import type { MarketProgram } from '@/features/bidding/constants'

export const isValueStackingSupported = (marketProgram: MarketProgram, country: CountryIdentifier): boolean => {
  const supportedPrograms = [
    'NORDICS_FCRD_DOWN_STATIC',
    'NORDICS_FCRD_UP_STATIC',
    'NORDICS_FCRD_DOWN_DYNAMIC',
    'NORDICS_FCRD_UP_DYNAMIC',
    'NORDICS_FCRN',
  ]
  return supportedPrograms.includes(marketProgram) && country.toLowerCase() === 'fi'
}
